import client from './client';

export interface ChatChannel {
  id: number;
  name: string;
  channel_type: 'general' | 'district' | 'topic';
  description?: string;
  is_active: boolean;
  message_count?: number;
}

export interface ChatMessage {
  id: number;
  channel_id: number;
  user_id: number;
  user_name?: string;
  text: string;
  image_url?: string;
  is_deleted: boolean;
  created_at: string;
}

export interface ChannelCreatePayload {
  name: string;
  channel_type: string;
  description?: string;
}

export interface ChatStats {
  total_channels: number;
  total_messages: number;
  active_today: number;
}

export const chatApi = {
  listChannels: () =>
    client.get<ChatChannel[]>('/api/admin/chat/channels'),

  createChannel: (data: ChannelCreatePayload) =>
    client.post('/api/admin/chat/channels', data),

  updateChannel: (id: number, data: Partial<ChannelCreatePayload & { is_active: boolean }>) =>
    client.patch(`/api/admin/chat/channels/${id}`, data),

  listMessages: (channelId: number, params?: { page?: number; limit?: number }) =>
    client.get<ChatMessage[]>(`/api/admin/chat/channels/${channelId}/messages`, { params }),

  deleteMessage: (messageId: number) =>
    client.delete(`/api/admin/chat/messages/${messageId}`),

  stats: () =>
    client.get<ChatStats>('/api/admin/chat/stats'),
};
